module.exports = __webpack_public_path__ + "media/guanzhi.b4d24e08.mp4";